module.exports = __webpack_public_path__ + "media/icons/reset-icon-white-0773b722.svg";